import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';
import CarrierSectionIconLegend from 'tailwind-components/CarrierSectionIconLegend/CarrierSectionIconLegend';

export default function CarrierSectionHeader({
  title,
  subtitle,
  legends = [],
  showUplineDisabled = false,
  children,
  as = 'h3',
  className = '',
  titleClassName = ''
}) {
  const showLegend = legends.length > 0 || showUplineDisabled;
  const TitleTag = as;
  const defaultTitleSize = as === 'h4' ? 'text-lg' : 'text-xl';

  return (
    <header className={cn('flex w-full flex-col gap-2', className)}>
      <div className='flex w-full items-start justify-between gap-4'>
        <div className='flex min-w-0 flex-1 flex-col items-start gap-2 text-left'>
          <TitleTag
            className={cn(
              'm-0 leading-none font-semibold text-gray-900',
              defaultTitleSize,
              titleClassName
            )}
          >
            {title}
          </TitleTag>
          {subtitle ? (
            <p className='m-0 text-sm text-gray-600'>{subtitle}</p>
          ) : null}
        </div>
        {showLegend ? (
          <CarrierSectionIconLegend
            legends={legends}
            showUplineDisabled={showUplineDisabled}
          />
        ) : null}
      </div>
      {children}
    </header>
  );
}

CarrierSectionHeader.propTypes = {
  title: propTypes.string.isRequired,
  subtitle: propTypes.string,
  legends: propTypes.arrayOf(
    propTypes.shape({
      carrierIcon: propTypes.string.isRequired,
      carrierIconColor: propTypes.string,
      carrierIconDescription: propTypes.string.isRequired
    })
  ),
  children: propTypes.node,
  as: propTypes.string,
  className: propTypes.string,
  titleClassName: propTypes.string,
  showUplineDisabled: propTypes.bool
};
